import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section } from './ui/Section';
import { useMetaPixelViewTracking, trackEvent } from '../utils/metaPixel';
export function Pricing() {
  // Track when pricing section is viewed
  useMetaPixelViewTracking('pricing', {
    content_category: 'pricing',
    content_type: 'product'
  });
  const features = ['6 Tomos — más de 300 páginas', '6 Bonos exclusivos de implementación', 'Tracker de Desinflamación 21 días', 'Ruta de compra para supermercados españoles', 'Kit SOS Antojos de uso inmediato', 'Guía Social para comer fuera en España', 'PDF descargable — acceso en 5 minutos', 'Actualizaciones gratuitas de por vida'];
  const handleClick = () => {
    trackEvent('InitiateCheckout', {
      content_name: 'Sistema Mimetismo Nutricional',
      value: 19.9,
      currency: 'EUR'
    });
  };
  return <Section id="pricing" data-id="element-154" data-mp="3h9hddq265g04">
      <h2 className="font-display text-2xl md:text-4xl font-bold text-center mb-3 text-brand-title" data-id="element-155" data-mp="3c8jx5j0pyw19">
        Accede al sistema completo
      </h2>
      <p className="text-center text-brand-secondary font-semibold mb-8 font-body" data-id="element-156" data-mp="3vynlio2kwdf5">
        Acceso completo e inmediato
      </p>

      <div className="flex justify-center mb-6" data-id="element-157" data-mp="4uyuqzbug69q">
        <img src="https://cdn.magicpatterns.com/uploads/1gwhDJbWYAzPqP47WvppdA/ChatGPT_Image_9_ago_2026__14_24_27-removebg-preview.png" alt="Sistema Mimetismo Nutricional™ — 6 Tomos + 6 Bonos Exclusivos" className="w-full max-w-[220px] object-contain" loading="lazy" data-id="element-158" data-mp="9ta4zb61wish" />
      </div>

      <div className="max-w-lg mx-auto bg-white border-2 border-brand-primary rounded-3xl p-8 md:p-10 shadow-card-lg" data-id="element-159" data-mp="3i7ipdvyf639k">
        <h3 className="font-heading text-lg font-bold text-brand-title mb-1 text-center" data-id="element-160" data-mp="3n63qdxlhwqz2">
          Sistema Mimetismo Nutricional™
        </h3>
        <p className="text-brand-textMuted text-sm font-body mb-6 text-center" data-id="element-161" data-mp="3rzy50mm8ufra">
          6 Tomos + 6 Bonos Exclusivos
        </p>

        <div className="space-y-3 mb-8" data-id="element-162" data-mp="2zh0zs08vvnsf">
          {features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-163" data-mp="2zf7twn63h7lh" data-mpi={i}>
              <CheckIcon className="w-5 h-5 text-brand-primary shrink-0 mt-0.5" data-id="element-164" data-mp="2rfjuj9slggki" />
              <span className="font-body text-brand-text text-sm" data-id="element-165" data-mp="2mgqizmwvazmz">
                {feature}
              </span>
            </div>)}
        </div>

        <div className="text-center border-t border-brand-border pt-6 mb-6" data-id="element-166" data-mp="318qx6mvy9igw">
          <div className="text-brand-textMuted text-sm font-body mb-1" data-id="element-167" data-mp="2w83a2caudlry">
            Valor total del pack:{' '}
            <span className="line-through" data-id="element-168" data-mp="28i8wfsip7t6n">€143</span>
          </div>
          <div className="text-brand-secondary font-heading font-bold text-xs uppercase tracking-wide mb-2" data-id="element-169" data-mp="23jz0hfp5gojz">
            Hoy
          </div>
          <div className="font-display text-5xl font-black text-brand-title mb-1" data-id="element-170" data-mp="2idtuxgok6bbn">
            €19,90
          </div>
          <div className="text-brand-textMuted text-sm font-body" data-id="element-171" data-mp="3tv3ctys1gvau">
            Pago único · Sin suscripción · Acceso de por vida
          </div>
        </div>

        <a href="https://www.manualeslistos.com/cart/62909676814666:1" target="_blank" rel="noopener noreferrer" onClick={handleClick} className="font-heading w-full bg-brand-primary hover:bg-brand-primaryHover text-white font-bold text-lg py-4 px-6 rounded-xl transition-colors text-center block shadow-card mb-3" data-id="element-172" data-mp="3ovz4tbgup3m3">
          Quiero acceso inmediato →
        </a>

        <div className="text-center text-brand-textMuted text-xs font-body mb-4" data-id="element-173" data-mp="3rfwwnth61ssi">
          Pago único · Acceso digital inmediato
        </div>

        <div className="flex items-center justify-center gap-4 text-xs text-brand-textMuted font-body" data-id="element-174" data-mp="j2y9jvnttch0">
          <span data-id="element-175" data-mp="o22lgu24xob1">🔒 Pago seguro SSL</span>
          <span data-id="element-176" data-mp="a9cvkejhjz8n">↩ Garantía 30 días</span>
          <span data-id="element-177" data-mp="a8b81ala9ka1">⚡ Acceso en 5 min</span>
        </div>
      </div>
    </Section>;
}